import {
  Link as OGLink,
  type LinkProps as OGLinkProps,
} from 'react-router-dom';

export type LinkProps = OGLinkProps;
export type LinkTo = LinkProps['to'];

export const Link = OGLink;
